module.exports = __webpack_public_path__ + "media/store/images/icon-buttons/caret-down-6eba003eba2d12e548dfbdfb1bd7bc07.svg";